import React from "react";
import { FormGroup, Input } from "reactstrap";
import moment from "moment";
import "react-image-crop/dist/ReactCrop.css";
class AdvForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formatTime(dateString) {
    return moment(dateString).format("YYYY-MM-DD");
  }

  render() {
    return (
      <div>
        <div className="d-flex align-items-center justify-content-around mb-4">
          <button
            type="button"
            className="btn btn-default"
            style={{ flex: 1 }}
            disabled={this.props.loading}
            onClick={this.props.submitArticle}
          >
            添加付費廣告
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            style={{ flex: 1 }}
          >
            預覽
          </button>
        </div>
        <p>
          預計價格：$
          {this.props.data.type === "top"
            ? 20 * this.props.data.vacancy_weeks
            : 10 * this.props.data.vacancy_weeks}
          + tax
        </p>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            標題
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.title}
            onChange={e => this.props.onTextInputChange(e, "title")}
          />
        </FormGroup>

        <FormGroup>
          <label htmlFor="exampleFormControlSelect1">選擇分類</label>
          <Input
            id="exampleFormControlSelect1"
            type="select"
            onChange={e => this.props.handleCheckBoxChange(e)}
          >
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(96) !== -1
                  : false
              }
              value={96}
            >
              工作求職
            </option>
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(97) !== -1
                  : false
              }
              value={97}
            >
              餐館服務
            </option>
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(98) !== -1
                  : false
              }
              value={98}
            >
              家政服務
            </option>
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(99) !== -1
                  : false
              }
              value={99}
            >
              維修保養
            </option>
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(100) !== -1
                  : false
              }
              value={100}
            >
              商家服務
            </option>
          </Input>
        </FormGroup>
        <FormGroup>
          <label htmlFor="exampleFormControlSelect1">選擇分類</label>
          <Input
            id="exampleFormControlSelect1"
            type="select"
            onChange={e => this.props.onTextInputChange(e, "type")}
          >
            <option selected={this.props.data.type === "right"} value={"right"}>
              側邊廣告
            </option>
            <option selected={this.props.data.type === "top"} value={"top"}>
              置頂廣告
            </option>
          </Input>
        </FormGroup>
        <FormGroup>
          <label htmlFor="exampleFormControlSelect1">期限</label>
          <Input
            id="exampleFormControlSelect1"
            type="select"
            onChange={e => this.props.onTextInputChange(e, "vacancy_weeks")}
          >
            <option selected={this.props.data.vacancy_weeks === 1} value={1}>
              一週
            </option>
            <option selected={this.props.data.vacancy_weeks === 2} value={2}>
              兩週
            </option>
            <option selected={this.props.data.vacancy_weeks === 3} value={3}>
              三週
            </option>
            <option selected={this.props.data.vacancy_weeks === 4} value={4}>
              四週
            </option>
          </Input>
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            聯繫人
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.contact}
            onChange={e => this.props.onTextInputChange(e, "contact")}
          />
        </FormGroup>

        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            電話
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.phone}
            onChange={e => this.props.onTextInputChange(e, "phone")}
          />
        </FormGroup>

        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            郵箱
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.email}
            onChange={e => this.props.onTextInputChange(e, "email")}
          />
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            備註
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.note}
            onChange={e => this.props.onTextInputChange(e, "note")}
          />
        </FormGroup>
      </div>
    );
  }
}

export default AdvForm;
